import { handleXcoreError, SaveSubCategoryError } from "@robe/core-api/errors";
import { SubCategory } from "@robe/core-types/category";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export enum SaveCategoryOperationMode {
  Update = "PUT",
  Create = "POST",
}

export type SaveSubCategory = Omit<SubCategory, "content">;

/**
 * @throws {SaveSubCategoryError}
 */
export const saveSubCategory = (category: SaveSubCategory, core: XcoreCore, mode: SaveCategoryOperationMode): BaseApiRequest<SubCategory> =>
  core
    .fetch("/api/category/subcategory", {
      ...core.getCtx(),
      method: mode,
      body: JSON.stringify(category),
    })
    .then((res, url) => (res.ok ? res.json() : handleSaveSubCategoryError(url, res)));

export const handleSaveSubCategoryError = handleXcoreError((...args) => new SaveSubCategoryError(...args));
